<template>
  <div>
    <header class="left_right">

      <div class="left_1">
        <div class="left_1_header">
          <p class="footer_wait" style="font-size:16px">面试人员列表</p>
          <el-button type="text" style="font-size:16px" @click="showImport">导入</el-button>
        </div>

        <div class="left_1_search">
          <el-form :inline="true" :model="searchFormData" class="demo-form-inline">
            <el-form-item style="width: 175px">
              <el-input placeholder="输入联系人名称搜索" v-model="searchFormData.name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search" icon="el-icon-search"></el-button>
            </el-form-item>
          </el-form>
        </div>

        <ul class="left_1_waitting">
          <li v-for="(item,index) in pageProps.records" :key="index">
            <el-checkbox :label="item.user_app_id" v-model="item.checked" :checked="item.checked">{{index+1}}号</el-checkbox>
            <el-avatar :src="item.user_avatar"></el-avatar>
            <p>{{ item.alias_name }}</p>
          </li>

          <div v-if="pageProps.records.length<=0" style="width:100%;text-align:center">
               <img src="@/assets/image/no_audition.png" style="width:150px"/> 
              <p style="color:#999999">暂时没有面试人员</p>
            </div>

        </ul>

        <section class="left_1_footer">
          <el-checkbox @change="selectAllUser">全选</el-checkbox>
          <el-button type="primary" @click="inviteWait">邀请等待</el-button>
          <el-button type="primary" @click="inviteInterview(1)">邀请面试</el-button>
        </section>
      </div>




      <main class="right_1">
        <div class="right_header">
          <div class="footer_one">
            <p>等待面试</p>
            <div>
              <el-checkbox @change="selectAllWait">全选</el-checkbox>
              <el-button type="text" @click="remove(1)">移回签到列表</el-button>
            </div>
          </div>

          <ul class="footer_pep">
            <li v-for="(item,index) in waitingData" :key="index">
              <el-checkbox :label="item.user_app_id" v-model="item.checked" :checked="item.checked">{{index+1}}号</el-checkbox>
              <el-avatar :src="item.user_avatar"></el-avatar>
              <p>{{ item.alias_name }}</p>
            </li>


            <div v-if="waitingData.length<=0" style="width:100%;text-align:center">
               <img src="@/assets/image/no_audition.png" style="width:150px"/> 
              <p style="color:#999999">暂时没有等待面试人员</p>
            </div>
          </ul>

          <section class="footer_invent">
            <el-button size="small" type="primary" @click="inviteInterview(2)">邀请面试</el-button>
          </section>
        </div>

        <div class="right_header">
          <div class="footer_one">
            <div class="footer_wait">面试进行中</div>
            <div>
              <el-checkbox @change="selectAllProgress">全选</el-checkbox>
              <el-button type="text" @click="remove(2)">移回签到列表</el-button>
            </div>
          </div>

          <ul class="footer_pep">
            <li v-for="(item,index) in progressData" :key="index">
              <el-checkbox 
              :label="item.user_app_id" 
              v-model="item.checked" 
              :checked="item.checked"
              @change="handleMultiSelect"
              >
              {{index+1}}号
            </el-checkbox>
              <el-avatar :src="item.user_avatar"></el-avatar>
              <p>{{ item.alias_name }}</p>
            </li>

            <div v-if="progressData.length<=0" style="width:100%;text-align:center">
               <img src="@/assets/image/no_audition.png" style="width:150px"/> 
              <p style="color:#999999">暂时没有面试中的人员</p>
            </div>
          </ul>

          <!--
          <div class="footer_invent">
            <el-button size="small" type="primary">邀请面试</el-button>
          </div>-->
        </div>
      </main>
    </header>

    <footer class="footer_list_other">
      <div class="footer_list_font">
        <p>审核列表</p>
        <el-button type="text" v-if="verifys.length>0"  @click="editTable">编辑表格</el-button>
      </div>

      <div class="footer_table">
        <div v-if="verifys.length<=0" style="text-align:center;padding: 30px;">
          <el-button type="primary"  @click="addTale">添加表格</el-button>
        </div>
        <el-table v-else :data="verifys" border>
          <el-table-column prop="title" label="考核项" width="120px" header-align='center' align='center'>
          </el-table-column>
          <el-table-column prop="type" label="极佳" width="120px" header-align='center' align='center' >
            <template slot-scope="{row}">
              <div  @click="row.type=1">
                <img src="@/assets/image/audition-select.png" v-if="row.type==1" style="width:30px"></img>
                <img src="@/assets/image/audition-unselect.png" v-else style="width:30px"></img>

              </div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="良好" width="120px" header-align='center' align='center'>
            <template slot-scope="{row}">
            <div  @click="row.type=2">
                <img src="@/assets/image/audition-select.png" v-if="row.type==2" style="width:30px"></img>
                <img src="@/assets/image/audition-unselect.png" v-else style="width:30px"></img>

            </div>
          </template>
          </el-table-column>
          <el-table-column prop="type" label="平常" width="120px" header-align='center' align='center'>
            <template slot-scope="{row}">
            <div  @click="row.type=3">
                <img src="@/assets/image/audition-select.png" v-if="row.type==3" style="width:30px"></img>
                <img src="@/assets/image/audition-unselect.png" v-else style="width:30px"></img>

            </div>
          </template>
          </el-table-column>
          <el-table-column prop="type" label="略差" width="120px" header-align='center' align='center'>

            <template slot-scope="{row}">
            <div  @click="row.type=4">
                <img src="@/assets/image/audition-select.png" v-if="row.type==4" style="width:30px"></img>
                <img src="@/assets/image/audition-unselect.png" v-else style="width:30px"></img>

            </div>
          </template>
          </el-table-column>
          <el-table-column prop="type" label="极差" width="120px" header-align='center' align='center'>

            <template slot-scope="{row}">
            <div  @click="row.type=5">
                <img src="@/assets/image/audition-select.png" v-if="row.type==5" style="width:30px"></img>
                <img src="@/assets/image/audition-unselect.png" v-else style="width:30px"></img>

            </div>
          </template>

          </el-table-column>
          <el-table-column prop="mark" label="备注" header-align='center'>
            <template slot-scope="scope">
              <el-input v-model="scope.row.mark" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="等级" width="120px" header-align='center' align='center'>
          
            <template slot-scope="{row}">
              <span v-if="row.type==1">S</span>
              <span v-if="row.type==2">A</span>
              <span v-if="row.type==3">B</span>
              <span v-if="row.type==4">C</span>
              <span v-if="row.type==5">D</span>

            </template>

            
          </el-table-column>
        </el-table>
      </div>

      <section class="footer_step" v-if="verifys.length>0">
        <!--态6通过面试，3备选，2淘汰-->
        <el-button type="primary" plain size="medium" @click="audit(6)" :disabled="multipleSelection.length!=1">通过</el-button>
        <el-button type="primary" plain size="medium" @click="audit(3)" :disabled="multipleSelection.length!=1">备用</el-button>
        <el-button type="primary" plain size="medium" @click="audit(2)" :disabled="multipleSelection.length!=1">淘汰</el-button>
      </section>
    </footer>

    <add-table-dialog ref="tableDialog" @initTable="initTable"></add-table-dialog>
    <import-dialog ref="importDialog"  @refresh="refresh"></import-dialog>
  </div>
</template>

<script>

import { auditList,updateAuditStatus,updateAudit,waitlist} from "@/api/director/interview/index";
import {getInterview,upInterviewStatus} from "@/api/director/interview/index.js";



import addTableDialog from './add-table-dialog.vue'
import importDialog from './import-dialog.vue'


export default {
  components: {
    addTableDialog,importDialog
  },


  data () {
    return {
   

      progressData:[],
      waitingData:[],

      pageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },

      searchFormData: {
        name: "",
        project_id:"",
        job_id:"",
        page: 0,
        limit: 0,
      },

      project_id:'',
      job_id:"",

      waitFormData:{
        project_id:"",
        job_id:"",
      },

      multipleSelection:[],

      verifys: [
       // {'title':'','mark':'','type':1}
      ],///1-s,2-a,3-b,4-c,5-d
      
    };
  },

  mounted () {
    
   // this.getAuditList();
   // this.getWaitList();
  },

  watch: {
      
    // 如果只需要监听对象中的一个属性值，则可以做以下优化：使用字符串的形式监听对象属性：
      project_id: {
        // 执行方法
        handler(newValue,oldValue) {
          console.log("oldValue",oldValue)
            console.log("newValue",newValue)
            if(newValue){
              this.getAuditList();
              this.getWaitList();
            }
            
        },

        
        deep: true, // 深度监听
        immediate: true  // 第一次改变就执行
      },

      job_id: {
        // 执行方法
        handler(newValue,oldValue) {
            console.log("oldValue",oldValue)
            console.log("newValue",newValue)
            if(newValue){
              that.getAuditList();
              that.getWaitList();
              that.getProgressList();
            }
        },
        deep: true, // 深度监听
        immediate: true  // 第一次改变就执行
      }
  },
  methods: {
    refresh(){
      that.getAuditList();
      that.getWaitList();
      that.getProgressList();
    },
    //导入
    showImport(){
      if(this.project_id==""||this.job_id==""){
        this.$message.warning("请选择项目和职位");
        return;
      }
      
      this.$refs.importDialog.init(this.project_id,this.job_id);
    },

    addTale(){
      this.$refs.tableDialog.init(this.verifys);

    },

    initTable(datas){
      if(datas.length<=0){
          return;
      }

      this.verifys=[];
      
      for (let item of datas) {
        this.verifys.push({
          'title':item.title,'mark':'','type':''
        });
      }
    },

    editTable(){
      this.$refs.tableDialog.init(this.verifys);
    },

    handleMultiSelect(e){
      this.multipleSelection=[];
      for (let item of this.progressData) {
          if(item.checked ==true){
            this.multipleSelection.push(item);
          }
        }
        this.$forceUpdate();
    },

    //全选择面试人员
    selectAllUser(e){
      console.log('e',e)
      for (let item of this.pageProps.records) {
          console.log(item)
          item.checked = e;
        }
        this.$forceUpdate();
    },

    //全选等待面试人员
    selectAllWait(e){
      for (let item of this.waitingData) {
          console.log(item)
          item.checked = e;
        }
        this.$forceUpdate();
    },

    //全选面试中人员
    selectAllProgress(e){
      for (let item of this.progressData) {
          console.log(item)
          item.checked = e;
        }
        this.$forceUpdate();
      
    },



    
    //通过
    audit(type){
      /*
      {
    "project_id": 15,
    "user_app_ids": [{"job_id":43,"user_app_id":56},{"job_id":43,"user_app_id":2}],
    "relation_status": 6,
    "verifys": [{'title':'动手能力','mark':'动手能力不错','type':1},{'title':'111','mark':'111','type':1}]
}
态6通过面试，3备选，2淘汰
      */ 

      var that=this;
      var user_app_ids=[];
      for (let item of this.progressData) {
          if(item.checked){
            user_app_ids.push({
              job_id:item.job_id,
              user_app_id:item.user_app_id
            });
          }
       }

       if(user_app_ids.length<=0){
         this.$message.error("请选择人员");
         return;
       }

       if(user_app_ids.length>1){
         this.$message.error("请选择1名面试人员");
         return;
       }

       var params={
        project_id:this.project_id,
        "relation_status": type,
        user_app_ids:user_app_ids,
        verifys:this.verifys
       };
       
       upInterviewStatus(params).then((response) => {
          if(response.code==200){
            that.refresh();
         
          }else{
            this.$message.error(response.msg?response.msg:"操作失败");
          }
        });
    },
   

    //邀请等待
    inviteWait(){
      var that=this;
      var user_app_ids=[];
      for (let item of this.pageProps.records) {
          console.log(item)
          if(item.checked){
            user_app_ids.push({
              job_id:item.job_id,
              user_app_id:item.user_app_id
            });
          }
       }

       if(user_app_ids.length<=0){
         this.$message.error("请选择人员");
         return;
       }

       var params={
        project_id:this.project_id,
        "interview_status": "1",
        user_app_ids:user_app_ids
       };
       
       updateAuditStatus(params).then((response) => {
          if(response.code==200){
            that.refresh();
          }else{
            this.$message.error(response.msg?response.msg:"操作失败");
          }
        });
    },


    //邀请面试
    inviteInterview(type){

      var that=this;
      var user_app_ids=[];
      if(type==1){
        for (let item of this.pageProps.records) {
          console.log(item)
          if(item.checked){
            user_app_ids.push({
              job_id:item.job_id,
              user_app_id:item.user_app_id
            });
          }
       }

      }else{
        for (let item of this.waitingData) {
          console.log(item)
          if(item.checked){
            user_app_ids.push({
              job_id:item.job_id,
              user_app_id:item.user_app_id
            });
          }
        }
      }
     
       if(user_app_ids.length<=0){
         this.$message.error("请选择人员");
         return;
       }

       var params={
        project_id:this.project_id,
        "interview_status": "2",
        user_app_ids:user_app_ids
       };
       
       updateAuditStatus(params).then((response) => {
          if(response.code==200){
            that.refresh();
          }else{
            this.$message.error(response.msg?response.msg:"操作失败");

          }
        });
    },


    //移到面试列表
    remove(type){
      var that=this;
      var user_app_ids=[];
      if(type==1){
        for (let item of this.waitingData) {
          console.log(item)
          if(item.checked){
            user_app_ids.push({
              job_id:item.job_id,
              user_app_id:item.user_app_id
            });
          }
       }

      }else{
        for (let item of this.progressData) {
          console.log(item)
          if(item.checked){
            user_app_ids.push({
              job_id:item.job_id,
              user_app_id:item.user_app_id
            });
          }
        }
      }
     
       if(user_app_ids.length<=0){
         this.$message.error("请选择人员");
         return;
       }

       var params={
        project_id:this.project_id,
        "interview_status": "0",
        user_app_ids:user_app_ids
       };
       
       updateAuditStatus(params).then((response) => {
          if(response.code==200){
            that.refresh();
          }else{
            that.$message.error(response.msg?response.msg:"操作失败");

          }
        });
    },


    search(){
      this.getAuditList();
    },

    //报名列表
    getAuditList () {
      var that = this;
      var params={
        project_id:that.project_id,
        job_id:that.job_id,
        invite_status:1

      };
     getInterview(params).then((response) => {
        if(response.code==200){
          that.pageProps.records = response.data.data;
          that.pageProps.total = response.data.total;
        }

        
      });
    },

    //等待面试
    getWaitList () {
      var that = this;
      var params={
        project_id:that.project_id,
        job_id:that.job_id,
        invite_status:2

      };

      getInterview(params).then((response) => {
        console.log(response);
        if(response.code==200){
          that.waitingData= response.data.data;
        }
       
      });
    },

    //面试中
    getProgressList () {
      var that = this;
      var params={
        project_id:that.project_id,
        job_id:that.job_id,
        invite_status:3
      };

      getInterview(params).then((response) => {
        console.log(response);
        if(response.code==200){
          that.progressData = response.data.data;
        }
       
      });
    },

    //接收从上个页面传过来的值
    setParams(project_id,job_id){
      
      this.project_id=project_id;
      this.job_id=job_id;
      
    }
  },
};
</script>

<style lang="scss" scoped>
.left_right {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 19px;
  .left_1 {
    width: 272px;
    overflow: hidden;
    height: 602px;
    margin-right: 19px;
    border-radius: 6px;
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
    .left_1_header {
      padding-top: 24px;
      padding-bottom: 18px;
      padding-right: 16px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      line-height: 30px;
      position: relative;
    }
    .left_1_search {
      width: 240px;
      height: 32px;
      padding-right: 16px;
      padding-left: 16px;
    }
    .left_1_waitting {
      margin: 10px 0;
      overflow-y: scroll;
      height: 410px;
      box-sizing: border-box;
      overflow-x: hidden;
      li {
        height: 50px;
        display: flex;
        align-items: center;
        padding-left: 16px;
        padding-right: 16px;
        .el-avatar--circle {
          width: 29px;
          height: 29px;
          margin-left: 20px;
          margin-right: 12px;
        }
      }
    }
    .left_1_footer {
      background-color: #fff;
      height: 68px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
    }
  }

  .right_1 {
    display: flex;
    flex-direction: column;
    .right_header {
      width: 909px;
      height: 291px;
      margin-bottom: 19px;
      border-radius: 6px;
      box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
      display: flex;
      flex-direction: column;
      .footer_one {
        margin: 0 16px;
        height: 55px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
          font-size: 16px;
        }
        div {
          .el-button {
            margin-left: 15px;
            font-size: 14px;
          }
        }
      }
      .footer_pep {
        padding: 0 16px;
        height: 174px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        overflow-y: auto;
        li {
          height: 58px;
          width: 210px;
          display: flex;
          align-items: center;
          &:last-child:nth-child(4n-1) {
            margin-right: 222px;
          }
          &:last-child:nth-child(4n-2) {
            margin-right: 445px;
          }
          .el-avatar--circle {
            width: 29px;
            height: 29px;
            margin-left: 20px;
            margin-right: 12px;
          }
        }
      }
      .footer_invent {
        padding: 20px 16px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}

.footer_list_other {
  border-radius: 6px;
  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);

  .footer_list_font {
    display: flex;
    justify-content: space-between;
    padding: 15px 15px 10px;
  }
  .footer_table {
    padding: 0 30px;
  }
  .footer_step {
    padding: 25px;
    display: flex;
    justify-content: space-evenly;
  }
}
</style>